import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import ReactDatetime from "react-datetime";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
} from "react-bootstrap"
import { Typeahead } from 'react-bootstrap-typeahead';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';



const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {

  const [swal, setSwal] = useAlert();
  const [employees, setEmployees] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const fetchEmployee = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}employees`, {
        params: { all: true }
      });

      setEmployees(response.data.items);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
  }

  const [fileName, setFileName] = useState("Upload File");

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (endDate < startDate || endDate === null) {


      event.preventDefault();
      event.stopPropagation();

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: 'End date should be bigger than start date.',
        }
      });

      return;
    }

    event.preventDefault();
    onApplyChanges();

    setValidated(true);
    setFileName('');
    setStartDate('');
    setEndDate('');
  };

  const handleEmployeeChange = (selected) => {
    const value = selected.length > 0 ? selected[0].EMP_ID : null;
    setSelectedEmployee(value);

    const fakeEvent = {
      target: {
        name: 'EMP_ID',
        value: value
      }
    };
    onChange(fakeEvent);
  };

  useEffect(() => {
    console.log(row?.START_DATE);

    onChange({target: {
      name: 'START_DATE',
      value: moment(startDate).format('DD-MM-YYYY')
    }});

    onChange({target: {
      name: 'END_DATE',
      value: null,
    }});

    setEndDate(null);

  }, [startDate]);

  useEffect(() => {
    onChange({target: {
      name: 'END_DATE',
      value: moment(endDate).format('DD-MM-YYYY')
    }});
  }, [endDate])

  useEffect(() => {

    fetchEmployee();
    setFileName('');
    setValidated(false);
  }, []);

  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      {swal}
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>Auditor Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="validationCustom01">
            <Form.Label>Employee ID</Form.Label>
            <Typeahead
              id="employee-selector"
              labelKey={(option) =>`${option.EMP_ID} - ${option.EMP_NAME}`}
              options={employees}
              selected={
                employees.filter((a) => a.EMP_ID === selectedEmployee)
              }
              onChange={handleEmployeeChange}
              placeholder="Select ID..."
            />
            {/* <Typeahead
              id="employee-selector"
              labelKey={(option) => option.EMP_NAME}
              options={employees}
              selected={employees.filter((a) => a.EMP_ID === row.EMP_ID)}
              onChange={(selected) => {
                setEmployees(selected.length > 0 ? selected[0].EMP_ID : null);
              }}
              placeholder="Select ID..."
            /> */}
            {/* <Form.Control as="select"
              name='EMP_ID'
              value={row.EMP_ID ?? ''}
              onChange={onChange}
              required
            >
              <option value=''>Select ID</option>
              {employees && employees.map((employee, key) => (
                <option key={key}value={employee.EMP_ID}>
                  {employee.EMP_ID} - {employee.EMP_NAME}
                </option>
              ))}
            </Form.Control> */}
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="validationCustom02">
            <Form.Label>Status</Form.Label>
            <Form.Control as="select"
              name="AUDITOR_STATUS"
              value={row.AUDITOR_STATUS ?? ''}
              onChange={onChange}
              required
            >
              <option value=''>Select Status...</option>
              <option value="Active">Active</option>
              <option value="InActive">InActive</option>

            </Form.Control>
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>

          <Row >
              <Col>
                <Form.Group controlId="validationCustom03">
                    <Form.Label>On Duty</Form.Label>
                    <ReactDatetime
                      inputProps={{
                        name:"START_DATE",
                        className: "form-control",
                        placeholder: "Date Picker Here",
                        required: true
                      }}
                      value={row?.START_DATE !== undefined ? moment(row?.START_DATE, 'DD-MMM-YYYY').format('MM/DD/YYYY') : startDate}
                      onChange={setStartDate}
                      timeFormat={false}
                    />
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                    <Form.Label>To</Form.Label>
                    <ReactDatetime
                      isValidDate={(current) => {
                        return current.isAfter(moment(row.START_DATE, 'DD-MM-YYYY').format('MM-DD-YYYY'))
                      }}
                      value={row?.END_DATE !== undefined ? moment(row?.END_DATE, 'DD-MMM-YYYY').format('MM/DD/YYYY') : endDate}
                      inputProps={{
                        name:"END_DATE",
                        className: "form-control",
                        placeholder: "Date Picker Here",
                      }}
                      onChange={setEndDate}
                      timeFormat={false}
                      autoComplete={false}
                    />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  </Form.Group>
              </Col>
          </Row>
          <Form.Group controlId="validationCustom04">
            <Form.Label>Decree</Form.Label>
            <Form.File
              id="custom-file"
              label="Choose file"
              custom
              name='FILE_UPLOAD'
              label={fileName}
              onChange={(e) => {
                onChange({target: {
                  name: 'FILE_UPLOAD',
                  value: e.target.files[0] ?? ''
                }});
                setFileName(e.target.files[0].name)
              }}
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" type="submit" >Save</Button>
      </Modal.Footer>
      </Form>
    </Modal>
  )
};

export default Popup;